import useWidth from '../../../../../components/Hooks/useWidth';
import useMoney from '../../../../../hooks/useMoney';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import { useUserHasOfflineDatabase } from '../../../../offline/database/offlineDatabase/hooks/useUserHasOfflineDatabase';
import { useTranslation } from '../../../../translation/TranslationContext';
import { useAbility } from '../../../../users/AbilityContext';
import { useGetOrderTotals } from '../../../hooks/useOrderTotals/order-totals.queries';
import getOrderListColumns from '../../../list/orderList.columns';
import { UseOrderListColumnsParams } from '../orderListPage.types';

export const useOrderListColumns = ({
  selectedTab,
  isOfflineMode = false,
}: UseOrderListColumnsParams) => {
  const ability = useAbility();
  const { mobileWidth } = useWidth();
  const { formatMoney } = useMoney();
  const { translate, locale } = useTranslation();
  const { userRole: role, team, hasIntegrations } = useApplicationContext();
  const userHasOfflineDatabase = useUserHasOfflineDatabase();

  const { data: orderTotals, isLoading: isLoadingOnlineTotals } = useGetOrderTotals({
    enabled: !isOfflineMode,
  });
  const { data: offlineTotals, isLoading: isLoadingOfflineTotals } = useGetOrderTotals({
    isOfflineMode: true,
    enabled: isOfflineMode || userHasOfflineDatabase,
  });

  const columns = getOrderListColumns({
    totals: orderTotals,
    offlineTotals,
    formatMoney,
    hasIntegrations,
    role,
    team,
    translate,
    locale,
    mobileWidth,
    selectedTab,
    ability,
    isOfflineMode,
  });

  return {
    columns,
    isLoadingTotals: isOfflineMode ? isLoadingOfflineTotals : isLoadingOnlineTotals,
  };
};
